// mixins/globalMixin.js

export default {
  onShow() {
    const getCurrentRoute = () => {
      const pages = getCurrentPages();
      const currentPage = pages[pages.length - 1] || {}; // 获取当前页面实例
      return currentPage.route; // 返回当前页面的路由
    };
    const route = getCurrentRoute();
    if (route) {
      const loadStartTime = getApp().globalData.pageLoadTimes[`/${route}`] || 0;
      const pageLoadTime = new Date().getTime() - loadStartTime;
      this.$Sensors.pageviewTrack({
        page_load_time: pageLoadTime,
      });
    }
  },
};
